import * as React from 'react'
import {FC} from 'react'
import {CircularProgress, makeStyles} from '@material-ui/core'
import Color from 'color'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: Color(theme.palette.background.default).alpha(0.6).string(),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 50,
        overflow: 'hidden',
    },
    loader: {
        width: (props: LoadingProps) => props.size || props.sm ? theme.spacing(5) : theme.spacing(30),
        height: (props: LoadingProps) => props.size || props.sm ? theme.spacing(5) : theme.spacing(30),
        position: 'relative',
    },
    spinner: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    },
    spinner_top: {},
    spinner_middle: {
        top: '4%',
        left: '4%',
        animationDelay: '.05s',
    },
    spinner_inner: {
        top: '7%',
        left: '7%',
        animationDelay: '.15s',
    },
}))
type LoadingProps = {
    loading?: boolean
    isSuspense?: boolean
    className?: string,
    size?: number
    sm?: boolean,
}
export const Loading: FC<LoadingProps> = (props) => {
    const {loading, isSuspense, className} = props
    const visible = loading || isSuspense
    const classes = useStyles(props)
    const classStr = [classes.root]
    className && classStr.push(className)
    if (!visible) return null
    return (
        <div className={classStr.join(' ')}>
            <div className={classes.loader}>
                <CircularProgress className={clsx(classes.spinner, classes.spinner_top)} size="100%" thickness={1}/>
                <CircularProgress className={clsx(classes.spinner, classes.spinner_middle)} size="92%" thickness={.8}/>
                <CircularProgress className={clsx(classes.spinner, classes.spinner_inner)} size="86%" thickness={.6}/>
            </div>
        </div>
    )
}